import React from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";

export default class TextArea extends React.Component
{
    state = {
        rows: 1,
        minRows: this.props.minRows,
        maxRows: this.props.maxRows
    };

    static propTypes = {
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        placeholder: PropTypes.string,

        autoresize: PropTypes.bool,
        minRows: PropTypes.number,
        maxRows: PropTypes.number,

        onBlur: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
    };

    static defaultProps = {
        placeholder: 'Write your text...',
        autoresize: false,
        minRows: 2,
        maxRows: 10
    };

    constructor(props) {
        super(props);
    }

    onChange = (event) => {
        this.props.onChange(event);

        if (this.props.autoresize) {
            this.resize();
        }
    };

    resize = () => {
        const textareaLineHeight = 20;
        const { minRows, maxRows } = this.state;

        const previousRows = this.ref.rows;
        this.ref.rows = minRows; // reset number of rows in textarea

        const currentRows = ~~(this.ref.scrollHeight / textareaLineHeight);

        if (currentRows === previousRows) {
            this.ref.rows = currentRows;
        }

        if (currentRows >= maxRows) {
            this.ref.rows = maxRows;
            this.ref.scrollTop = this.ref.scrollHeight;
        }

        this.setState({
            rows: currentRows < maxRows ? currentRows : maxRows,
        });
    };

    componentDidMount()
    {
        this.resize();
    }

    /**
     * If the component gets unmounted (Slide Element is de-selected),
     * then the onBlur will not trigger and save the new content.
     */
    componentWillUnmount()
    {
        this.props.onBlur();
    }

    render()
    {
        const {
            label,
            onChange,
            onBlur,
            autoresize,
            minRows,
            maxRows,
            className,
            ...otherProps
        } = this.props;

        const classes = classNames(
            className,
            "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
        );

        return <div>
            <label>
                { this.props.label }
                <textarea
                    ref={ref => this.ref = ref}
                    className={classes}
                    onChange={this.onChange}
                    onBlur={onBlur}
                    rows={this.state.rows}
                    {...otherProps}
                />
            </label>
        </div>;
    }
}
